import type { Point } from "./Point";

export function serializePoint({ x, y }: Point): string {
  return `${x},${y}`;
}
